import {dependencies} from "../dependencies/Dependeencies";

export function patchCustomer(data) {

    const { idService } = dependencies;

    return idService.patchCustomerData(data);
}